import React from "react";

const NotFound: React.FC = () => {
  return <div>404 - Not Found</div>;
};

export default NotFound;
